<div class="modal-header pb-0">
  <button class="button-close mb-2" mat-button [mat-dialog-close]="false">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
    </svg>
  </button>
</div>

<mat-dialog-content *ngIf="data?.type && !data?.runPay">
  <div class="d-flex align-items-center mb-3 justify-content-center">
    <h2 mat-dialog-title class="m-0">Valor Portal Guide</h2>
  </div>
  <ol>
    <li>
      <strong>Login:</strong>
      <ul>
        <li>Go to the Valor Portal.</li>
        <li>Enter your username and password to log in.</li>
        <li>(If you don’t have an account, register first.)</li>
      </ul>
    </li>
    <li>
      <strong>Navigate to Settings:</strong>
      <ul>
        <li>Once logged in, look at the left-hand sidebar menu.</li>
        <li>Click on <strong>Settings</strong>.</li>
      </ul>
    </li>
    <li>
      <strong>Open the Webhook Tab:</strong>
      <ul>
        <li>In the Settings section, find the <strong>Webhook</strong> tab and click on it.</li>
      </ul>
    </li>
    <li>
      <strong>Add a Webhook:</strong>
      <ul>
        <li>Enter the Webhook URL:
          <code>{{url}}</code>
        </li>
        <li>Enable the toggle for the webhook.</li>
        <li>
          Select the required actions for entities like:
          <ul>
            <li><strong>USER:</strong> ADD, UPDATE, DELETE</li>
            <li><strong>TRANSACTION:</strong> ADD, APPROVED</li>
            <li><strong>RECURRING:</strong> ADD, UPDATE</li>
          </ul>
        </li>
      </ul>
    </li>
    <li>
      <strong>Save:</strong>
      <ul>
        <li>Once all configurations are done, click <strong>Save</strong> to apply your webhook settings.</li>
      </ul>
    </li>
  </ol>
</mat-dialog-content>


<mat-dialog-content *ngIf="data?.type && data?.runPay">
  <div class="d-flex align-items-center mb-3 justify-content-center">
    <h2 mat-dialog-title class="m-0">Run Payments Portal Guide</h2>
  </div>
  <ol>
    <li>
      <strong>Login:</strong>
      <ul>
        <li>Go to the Run Payments Merchant Portal.</li>
        <li>Enter your Email and Password to log in.</li>
        <li>(If you don’t have an account, register first.)</li>
      </ul>
    </li>
    <li>
      <strong>Navigate to Settings:</strong>
      <ul>
        <li>Once logged in, look at the left-hand sidebar menu.</li>
        <li>Click on <strong>Settings</strong>.</li>
      </ul>
    </li>
    <li>
      <strong>Open the General Tab and Locate MID:</strong>
      <ul>
        <li>Scroll down to the <strong>Locations</strong> section.</li>
        <li>You will see your location listed (e.g., Service Galaxy UAT).</li>
        <li>The number shown in brackets (e.g., <strong>800000002211</strong>) is your <strong>MID</strong>.
        </li>
      </ul>
    </li>
    <li>
      <strong>Copy the MID:</strong>
      <ul>
        <li>Select the number inside the brackets.</li>
        <li>Right-click and choose <strong>Copy</strong> or press <strong>Ctrl + C</strong>.</li>
        <li>Paste the MID in the Run Payments MID Input box in Service Galaxy.</li>
      </ul>
    </li>
    <li>
      <strong>Get API Credentials:</strong>
      <ul>
        <li>Now go to the <strong>Developer API</strong> tab.</li>
        <li>Click on the <strong>Create</strong> button.</li>
        <li>This will generate your API credentials.</li>
      </ul>
    </li>

    <li>
      <strong>Copy Required Keys:</strong>
      <ul>
        <li>Copy the following details:</li>
        <ul>
          <li><strong>API Key</strong></li>
          <li><strong>Public Key</strong></li>
          <li><strong>Refresh Token</strong></li>
        </ul>
        <li>Paste them into the respective fields in the application.</li>
      </ul>
    </li>
    <li>
      <strong>Connect:</strong>
      <ul>
        <li>Once all configurations are done, click <strong>Connect</strong> to configure your settings.</li>
      </ul>
    </li>
  </ol>
</mat-dialog-content>


<mat-dialog-actions>
  <!-- <button mat-button mat-dialog-close>Close</button> -->
</mat-dialog-actions>
